import React, { ReactNode } from 'react';
import '../../../styles/CarelonRx/banner.css';

interface BannerProps {
  title: string;
  subtitle?: string;
  children?: ReactNode;
}

const Banner: React.FC<BannerProps> = ({ title, children }) => {
  return (
    <div className="crx-ribbon-container">
      <div className="ribbon-title" tabIndex={0}>
          {title}
        </div>
      <div className="crx-ribbon">
        <div className="super-graphic-image-extension"></div>
        <div className="super-graphic-image">
          <img 
            src="/assets/carelonRx/images/Supergraphic.png" 
            srcSet="/assets/carelonRx/images/Supergraphic@2x.png 2x, /assets/carelonRx/images/Supergraphic@3x.png 3x"
            alt="" 
            aria-hidden="true"
          />
        </div>
      </div>
      {children && <div className="banner-content">{children}</div>}
    </div>
  );
};

export default Banner;
